import { useContentfulInspectorMode } from "@contentful/live-preview/react";
import { Stack } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import type { ContentfulImageWithFocus } from "../../../common/types/cmsTypes";
import FullWidthBackground from "../../FullWidthBackground";
import ImageWithFocus from "../ImageWithFocus";
import { type ArticleProps, prefaceFont } from "./Article";
import PublishDate from "./PublishDate";

const StandardArticleHero = ({ article, id }: ArticleProps) => {
   const inspectorProps = useContentfulInspectorMode();
   const headerImage = (article.fields.headerImage as ContentfulImageWithFocus) || undefined;
   const { title, preface } = article.fields;

   return (
      <div className="relative mb-10">
         <FullWidthBackground color="bg-background-tinted" />
         <Stack className="relative w-full py-8 md:flex-row lg:py-16 md:gap-10" gap={4}>
            <Stack justify="center" align="start" className="md:w-1/2 md:gap-8" gap={5}>
               <h1
                  className="mb-0 text-3xl lg:text-5xl"
                  {...inspectorProps({
                     entryId: id,
                     fieldId: "title"
                  })}
               >
                  {title}
               </h1>
               <p
                  className={cn(prefaceFont, "mb-0")}
                  {...inspectorProps({
                     entryId: id,
                     fieldId: "preface"
                  })}
               >
                  {preface}
               </p>
               <PublishDate createdAt={article.sys.createdAt} updatedAt={article.sys.updatedAt} className="mb-0" />
            </Stack>
            <div className="md:w-1/2">
               {headerImage && (
                  <div className="">
                     <ImageWithFocus
                        width={1250}
                        ratio="3x2"
                        key={headerImage.sys.id}
                        entryId={headerImage.sys.id}
                        placement="aboveFold"
                        className="object-cover rounded-md"
                        {...inspectorProps({
                           entryId: id,
                           fieldId: "headerImage"
                        })}
                        imageFromParent={headerImage}
                     />
                  </div>
               )}
            </div>
         </Stack>
      </div>
   );
};

export default StandardArticleHero;
